import { useEffect, useRef, useState } from 'react'

type RefInterval = ReturnType<typeof setInterval> | undefined

const useExpiryDateCountdown = (targetDate) => {
  const countDownDate = new Date(targetDate).getTime()
  const currentDate = new Date().getTime()
  const isValidDate = countDownDate > currentDate
  const initialCountDown = isValidDate ? countDownDate - currentDate : 0

  const refInterval = useRef<RefInterval>(undefined)
  const [countDown, setCountDown] = useState(initialCountDown)

  useEffect(() => {
    if (refInterval.current) {
      clearInterval(refInterval.current)
      setCountDown(initialCountDown)
    }

    refInterval.current = setInterval(() => {
      const curDate = new Date().getTime()
      const isValid = countDownDate > curDate

      if (isValid) {
        setCountDown(countDownDate - curDate)
      }
    }, 1000 * 60)

    return () => {
      clearInterval(refInterval.current)
    }
  }, [countDownDate])

  return getReturnValues(countDown)
}

const getReturnValues = (countDown) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24))
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  )
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000)

  return [days, hours, minutes, seconds]
}

export default useExpiryDateCountdown
